// originally copied from https://github.com/zeit/next.js/blob/canary/examples/with-sentry/utils/sentry.js

// NOTE: This require will be replaced with `@sentry/browser` when
// process.browser === true thanks to the webpack config in next.config.js
import { Debug, Dedupe, ExtraErrorData } from "@sentry/integrations";
import * as Sentry from "@sentry/node";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import { pick } from "lodash";
import { useEffect } from "react";
import AppIntegration from "./AppIntegration";
import nextRewrite from "./nextRewrite";
import SentryFullStory from "./sentry-fullstory";
import UserIntegration from "./UserIntegration";

const sentryOptions = {
  enabled: process.env.NODE_ENV === "production",
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  maxBreadcrumbs: 50,
  integrations: [
    new ExtraErrorData({ depth: 5 }),
    new Dedupe(),
    new UserIntegration(),
    new AppIntegration(),
    new SentryFullStory(),
    new TracingIntegrations.BrowserTracing(),
    nextRewrite,
  ],
  beforeSend: (event) => {
    delete event.extra?.initialPropsCtx;
    return event;
  },
};

if (process.env.NODE_ENV !== "production") {
  sentryOptions.integrations.push(
    new Debug({
      debugger: false, // Trigger DevTools debugger
    })
  );
}

Sentry.init(sentryOptions);
Sentry.configureScope((scope) => scope.setTag("ssr", !process.browser));

export { Sentry };
export const captureException = Sentry.captureException;

export const useSentryFeatureTag = (feature) => {
  useEffect(() => {
    Sentry.setTag("feature", feature);
    return () => {
      Sentry.setTag("feature", null);
    };
  }, [feature]);
};

export const captureExceptionWithCtx = (err, ctx) => {
  Sentry.withScope((scope) => {
    if (ctx) {
      scope.setExtras({
        ...pick(ctx.req, ["url", "method", "headers"]), // Server side
        ...pick(ctx, ["pathname", "query"]), // Client side
        initialPropsCtx: ctx,
      });
    }
    Sentry.captureException(err);
  });
};
